/* eslint-disable */
import ctype from 'component-type';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the type of a given `handler` is invalid
 * @export
 * @class I18nInvalidHandlerTypeError
 * @extends {Error}
 */
export class I18nInvalidHandlerTypeError extends Error {
  /**
   * Creates an instance of I18nInvalidHandlerTypeError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidHandlerTypeError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidHandlerTypeError`;
  }
}

/**
 * Called when the type of a given `handler` is invalid
 * @param {any} handler The invalid `handler`
 * @returns {never} never
 */
const throwI18nInvalidHandlerTypeError = (handler) => {
  throw new I18nInvalidHandlerTypeError(
    stripIndent(`
    Expected "handler" to be of type Function.
    Got: "${ctype(handler)}".
    `),
  );
};

export default throwI18nInvalidHandlerTypeError;
